import { RosterScreen, useCommonDialogContext } from '@enter/core';
import { inject, observer } from 'mobx-react';
import React, { useContext, useState } from 'react';
import { DialogContext } from 'services';
import { IInjectedRootStore } from 'stores';
import { createProviderRosterStore } from './roster.store';

/**
 * The provider app's Roster (FE-109): the shared core screen with this app's store and dialogs.
 *
 * The store lives with the page rather than on the root store: it is built when the page opens —
 * demo mode switches with a reload, so it is settled by then — and nothing else in the app reads it.
 * Open to every user of the account (Settings → Roster); it is read-only on this API.
 */
export const Roster = inject('rootStore')(
    observer((props: {}): React.ReactElement => {
        const { rootStore } = props as IInjectedRootStore;
        const [store] = useState(() => createProviderRosterStore(rootStore.isDemo()));
        const dialog = useCommonDialogContext(useContext(DialogContext));
        return <RosterScreen store={store} dialog={dialog} />;
    }),
);
